$(function () {
  tour = {
    name: 'tour',
    steps: [
		        {
				    title: 'HalpMEEEE',
				    contents: 'Halp message',
        backdrop: false,
        backdropContainer: 'body',
        parent: '',
        onStart: function (tour) {},
        onFinish: function (tour) {},
        onNext: function (tour) {},
        onPrev: function (tour) {},
        reflex: false,
		        },
    ],
    template: '<div class="halp_popup"><div class="halp_title"></div><div class="halp_contents"></div><div> class="halp_buttons"></div><div class="halp_close"></div></div>',
  };
});

function halp_init() {
  $.each(tour.steps, function (k, v) {
    popupDiv = $(tour.template);
    $('.halp_title', popupDiv).html(v.title);
    $('.halp_contents', popupDiv).html(v.contents);

    $('body').before(popupDiv);
  });
}
